export default "__VITE_ASSET__056cd4cb__"